export enum Environment {
  Local = "local",
  Develop = "dev",
  Staging = "stage",
  Production = "prod",
}

export const ProductionEnvironments = [Environment.Production];
